export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8251.5ce313b0.jpg";